export default __webpack_public_path__ + "static/media/Greater Split Vertical.b70a9f57.png";